'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 5,
    bottom: 22,
    left: 60,
    right: 15
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding
  };
};
module.exports = Params;